import { AnyAction, Dispatch } from 'redux';
import { BillingAccountDetail, ParticipantsState, ParticipantsStateActions } from './participants-models';

const InitialState: ParticipantsState =
{
	billingAccountDetail: null,
	billingAccountDetailLoaded: false,
	requesting: false,
};



export const participantsReducer = (state = InitialState, action: AnyAction): ParticipantsState => {

	switch (action.type) {

		case ParticipantsStateActions.BEGIN_REQUEST_BILLING_ACCOUNT_DETAIL:
			return {
				...state,
				requesting: true,
			};

		case ParticipantsStateActions.END_REQUEST_BILLING_ACCOUNT_DETAIL:
			return {
				...state,
				requesting: false,
			};
		case ParticipantsStateActions.SET_BILLING_ACCOUNT_DETAIL:
			return {
				...state,
				billingAccountDetail: action.payload,
				billingAccountDetailLoaded: true,
				requesting: false,
			};
		case ParticipantsStateActions.UNLOAD_BILLING_ACCOUNT_DETAIL_STATE:
			return {
				billingAccountDetail: null,
				billingAccountDetailLoaded: false,
				requesting: false,
			};

		default: return state;
	}
};


export const setBillingAccountDetail = (billingAccountDetail: BillingAccountDetail) => {
	return {
		type: ParticipantsStateActions.SET_BILLING_ACCOUNT_DETAIL,
		payload: billingAccountDetail,
	};
};

export const beginBillingAccountDetailRequest = () => {
	return {
		type: ParticipantsStateActions.BEGIN_REQUEST_BILLING_ACCOUNT_DETAIL,
	};
};

export const endBillingAccountDetailRequest = () => {
	return {
		type: ParticipantsStateActions.END_REQUEST_BILLING_ACCOUNT_DETAIL,
	};
};

export const unloadParticipantsState = () => {
	return {
		type: ParticipantsStateActions.UNLOAD_BILLING_ACCOUNT_DETAIL_STATE,
	};
};

export const dispatchSetBillingAccountDetail = (dispatch: Dispatch<any>, onSuccess?: (res: any) => void) => (response) => {
	dispatch(setBillingAccountDetail(response.data));
	if (onSuccess) {
		onSuccess(response?.data);
	}
};
